import { Directive, ElementRef, Input } from '@angular/core';

/**
 * Directive for focusing to a enabled input of a form element
 *
 * @export
 */
@Directive({ selector: '[appFocusOn]' })
export class FocusOnDirective {
  private isReady: boolean;

  @Input('appFocusOn')
  set ready(value: boolean) {
    this.isReady = value;
    if (this.isReady) {
      this.focusOnEnabledInput();
    }
  }

  /**
   * Creates an instance of FocusOnDirective.
   */
  constructor(private el: ElementRef) {
  }

  /**
   * Finds the input element, and invokes focus method
   *
   */
  private focusOnEnabledInput(): void {
    const input = this.el.nativeElement;
    if (input.disabled === false) {
      setTimeout(() => {
        input.focus();
      });
      return;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/focus-on/focus-on.directive.ts